import ProblemDetail from './problem-detail';
import BaseError from '../';
export default class ApiError extends BaseError implements ProblemDetail {
  readonly name: string = "ApiError";
  type: string;
  detail: string;
  title: string;
  status: number;

  constructor(problem: ProblemDetail, cause: Error | null = null) {
    super(problem.title, cause);
    this.detail = problem.detail;
    this.status = problem.status;
    this.title = problem.title;
    this.type = problem.type;
  }
}
